import React, { Component } from "react";
import { Row, Col, Alert } from 'reactstrap';
import opRight from '../../imgs/op_right.png'

export class SanQiHuYuInviteSuccess extends Component {
    render() {
        return (
            <div>
                <Row>
                    <Col sm="12" md={{ size: 8, offset: 2 }}>
                        <div style={{ textAlign: "center", padding: "15px" }}>
                            <img alt={"Well Done"} src={opRight} style={{ width: "100px" }} />
                        </div>
                        <Alert color="success">
                            <h4 className="alert-heading">已接受笔试邀约！</h4>
                            <p>成功接受笔试邀约，请您通过笔试链接作答。</p>
                            <hr />
                            <p className="mb-0">请点击右上角关闭此页面，祝您笔试顺利。</p>
                        </Alert>
                    </Col>
                </Row>
            </div>
        )
    }
}